import React, { useContext, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useAuth0 } from "@auth0/auth0-react";
import {
    Box,
    ListItemIcon,
    ListItemText,
    MenuList,
    MenuItem,
    Paper,
} from "@mui/material";

import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

import PermissionGuard from "../../contexts/PermissionContext";

import RightClickMenu from "./RightClickMenu";
import ConfirmActionDialog from "../dialog/ConfirmActionDialog";


export default function SourcesRightClick(props) {

    const {
        children,
        deleteSource,
        source,
    } = props
    const [menuPosition, setMenuPosition] = useState(null);
    const [dialogOpen, setDialogOpen] = useState(false)


    const handleContextMenu = (event) => {
        event.preventDefault();
        setMenuPosition(
            menuPosition === null
            ?
                {
                    mouseX: event.clientX,
                    mouseY: event.clientY
                }
            :
                null
        );
    };

    const menuClose = () => {
        setMenuPosition(null)
    };

    const dialogClose = () => {
        setDialogOpen(false)
    }

    const onDeleteClick = () => {
        setDialogOpen(true)
        menuClose()
    };

    function handleClick() {

        deleteSource()
        
        setDialogOpen(false)
    }

    return (
        <>
            <RightClickMenu
                content={
                    <MenuList>
                        <PermissionGuard permission={['delete:source']}>
                            <MenuItem onClick={onDeleteClick}>
                                <ListItemIcon><DeleteForeverIcon  style={{fill: 'rgb(255, 255, 255)'}}/></ListItemIcon>
                                <ListItemText>{`Delete ${source ?? ''}`}</ListItemText>
                            </MenuItem>
                        </PermissionGuard>
                    </MenuList>
                }
                handleClose={menuClose}
                handleContextMenu={(e) => handleContextMenu(e)}
                menuPosition={menuPosition}
            >
                {children}
            </RightClickMenu>
            {dialogOpen && createPortal(
                <ConfirmActionDialog
                    clickAway={dialogClose}
                    handleClick={handleClick}
                    open={dialogOpen}
                />
                ,document.body
            )}
        </>
    )
}